<ion-app>

  <app-app-header app-header></app-app-header>

</ion-app>